import HeaderAnswer from "./HeaderAnswer";
import { Observer } from "mobx-react-lite";
import { useStores } from "../../store";
import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import { toJS } from "mobx";
import { FaRegDotCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Loader from "../reusble_components/loader";

export default function Answer() {
  const branch = localStorage.getItem("branch");
  const navigate = useNavigate();
  const { MockStore } = useStores();
  return (
    <Observer>
      {() => {
        return (
          <div className="md:px-[10%] lg:px-[10%]">
            <HeaderAnswer
              totalQue={MockStore.question[MockStore.section]?.length}
              visitedQue={MockStore.questionNumber}
            />
            <Loader loader={MockStore.loader} />
            <div className="bg-gray-100 md:mt-0 lg:mt-0 mt-4 w-full h-[100%] p-5 md:p-14 rounded-3xl">
              <div className="flex flex-col  pb-4 ">
                <span className="flex flex-row justify-between">
                  <span className="text-primary font-semibold">
                    {MockStore.section}
                  </span>
                  <span>
                    {MockStore.question[MockStore.section][
                      Number(MockStore.questionNumber) - 1
                    ]?.answer?.toUpperCase() ===
                    MockStore.question[MockStore.section][
                      Number(MockStore.questionNumber) - 1
                    ]?.userAns?.toUpperCase()
                      ? "Correct"
                      : "Incorrect"}
                  </span>
                </span>{" "}
                <span>Question {MockStore.questionNumber} </span>
                <span>
                  {MockStore?.question[MockStore.section][
                    Number(MockStore.questionNumber) - 1
                  ]?.question
                    ? MockStore.question[MockStore.section][
                        Number(MockStore.questionNumber) - 1
                      ].question
                    : ""}
                </span>
              </div>
              <div className="flex flex-col gap-4 ">
                {/* {MockStore.section === "Aptitude" &&
                MockStore.question[MockStore.section][
                  Number(MockStore.questionNumber) - 1
                ].options.map((option, index) => (
                  <label
                    key={index}
                    className={`flex flex-row items-center justify-between p-4 bg-white rounded-2xl ${
                      selectedOption === option ? "border-primary" : ""
                    }`}
                  >
                    <span>{option}</span>
                    <input
                      type="radio"
                      name="option"
                      className="text-primary"
                      value={option}
                      checked={selectedOption === option}
                      onChange={() => handleOptionChange(option)}
                    />
                  </label>
                ))} */}
                {MockStore?.question[MockStore.section][
                  Number(MockStore.questionNumber) - 1
                ]?.options &&
                  Object.entries(
                    MockStore.question[MockStore.section][
                      Number(MockStore.questionNumber) - 1
                    ].options
                  ).map(([key, value], index) => (
                    <label
                      key={index}
                      className={`flex flex-row items-center justify-between p-4 bg-white rounded-2xl
                      ${
                        MockStore.question[MockStore.section][
                          Number(MockStore.questionNumber) - 1
                        ].answer === key
                          ? "border border-green-500 text-green-500"
                          : "text-gray-400"
                      }
                      ${
                        MockStore.question[MockStore.section][
                          Number(MockStore.questionNumber) - 1
                        ]?.userAns === key
                          ? "border border-primary text-primary"
                          : ""
                      } `}
                    >
                      <span className="flex flex-row justify-between items-center w-[100%]">
                        {value} <FaRegDotCircle />
                      </span>
                      {/* <input
                        type="radio"
                        name="option"
                        className="text-primary"
                        readOnly
                        //   onChange={() => {
                        //     handleOptionChange(key);
                        //     MockStore.question[MockStore.section][
                        //       Number(MockStore.questionNumber) - 1
                        //     ].userAns = key;
                        //     MockStore.setAnswer();
                        //     console.log("answer", MockStore.Answer);
                        //   }}
                        checked={
                          MockStore.question[MockStore.section][
                            Number(MockStore.questionNumber) - 1
                          ].userAns === key
                        }
                      /> */}
                    </label>
                  ))}
              </div>
              <div className="flex justify-between mt-4">
                {!(
                  MockStore.questionNumber === "1" &&
                  MockStore.section.toUpperCase() === "APTITUDE"
                ) ? (
                  <button
                    className={`flex flex-row items-center  gap-2 ${
                      MockStore.questionNumber === "1" &&
                      MockStore.section.toUpperCase() === "APTITUDE"
                        ? ""
                        : ""
                    } `}
                    onClick={() => {
                      if (MockStore.questionNumber !== "0") {
                        MockStore.setQuestionNumber(
                          String(Number(MockStore.questionNumber) - 1)
                        );
                      }
                      if (MockStore.questionNumber === "0") {
                        if (MockStore.section.toUpperCase() === "REASONING") {
                          MockStore.setSection("APTITUDE");
                          MockStore.setQuestionNumber(
                            MockStore.aptitude.length
                          );
                        } else if (
                          MockStore.section.toUpperCase() === "VERBAL"
                        ) {
                          MockStore.setSection("REASONING");
                          MockStore.setQuestionNumber(
                            MockStore.reasonong.length
                          );
                        } else if (MockStore.section.toUpperCase() === "CORE") {
                          MockStore.setSection("VERBAL");
                          MockStore.setQuestionNumber(MockStore.verbals.length);
                        }
                      }
                    }}
                    disabled={MockStore.questionNumber === 1}
                  >
                    <IoMdArrowRoundBack className="text-primary"></IoMdArrowRoundBack>
                    Previous
                  </button>
                ) : (
                  <button></button>
                )}
                <button
                  className={`flex flex-row items-center gap-2
                  ${
                    MockStore.section === "CORE" &&
                    Number(MockStore.questionNumber) === MockStore.core.length
                      ? "hidden"
                      : ""
                  }
                  `}
                  onClick={() => {
                    console.log(toJS(MockStore.question));
                    if (
                      Number(MockStore.questionNumber) !==
                      MockStore.question[MockStore.section]?.length
                    ) {
                      MockStore.setQuestionNumber(
                        String(Number(MockStore.questionNumber) + 1)
                      );
                    } else {
                      if (MockStore.section.toUpperCase() === "APTITUDE") {
                        MockStore.setSection("REASONING");
                        MockStore.setQuestionNumber("1");
                      } else if (
                        MockStore.section.toUpperCase() === "REASONING"
                      ) {
                        MockStore.setSection("VERBAL");
                        MockStore.setQuestionNumber("1");
                      } else if (MockStore.section.toUpperCase() === "VERBAL") {
                        MockStore.setSection("CORE");
                        MockStore.setQuestionNumber("1");
                      }
                    }
                  }}
                >
                  Next
                  <IoMdArrowRoundForward className="text-primary"></IoMdArrowRoundForward>
                </button>
              </div>
              <div className="flex justify-end mt-5 w-[100%]">
                <button
                  className=" bg-primary text-white border rounded-xl  py-2 px-4"
                  onClick={async () => {
                    navigate(
                      `/dashboard/mockexamreport?id=${localStorage.getItem(
                        "mockTestId"
                      )}`
                    );
                  }}
                >
                  {" "}
                  Show the Report
                </button>
              </div>
            </div>
          </div>
        );
      }}
    </Observer>
  );
}
